import Footer from '../footer';
import Header from '../header/header';
import { CommonLayoutProps } from '@/types/other';
const Layout = ({
  children,
}: CommonLayoutProps & { isAuthenticated?: boolean }) => {
  return (
    <>
      <div>
        <div>
          <Header />
        </div>
        <main>{children}</main>
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Layout;
